import { defineRouter } from '#q-app/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';
import { useAuthStore } from 'src/stores/auth';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter((/* { store, ssrContext } */) => {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  // 🚀 路由守衛設定
  Router.beforeEach((to) => {
    const authStore = useAuthStore();

    if (to.path === '/login' && authStore.isLoggedIn()) {
      return '/'; // 直接 return 路徑，取代 next('/')
    }

    const requiresAuth = to.meta.requiresAuth !== false && to.path !== '/login';

    if (requiresAuth && !authStore.isLoggedIn()) {
      return '/login'; // 沒登入踢回登入頁，取代 next('/login')
    }

    return true; // 放行，取代 next()
  });

  return Router;
});
